<script>
import {
  fetchLangsByName,
  createLang,
  updateLang,
  deleteLang,
} from '@apis/admin/lang'
import map from 'lodash/map'
import find from 'lodash/find'
import truncate from 'lodash/truncate'
import defaults from 'lodash/defaults'
import date from 'locutus/php/datetime/date'
import filter from 'lodash/filter'

export default {
  props: {
    locales: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      lang_name: '',
      langs: [],
      action: 'READ',
    }
  },
  created() {
    this.init()
  },
  methods: {
    truncate,
    init() {
      this.loading = true
      this.lang_name = this.name.length
        ? this.name
        : `userLang${date('YmdHis')}`
      this.action = this.name.length ? 'READ' : 'CREATE'
      Promise.all([this.loadLangs()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadLangs() {
      const { langs } = await fetchLangsByName(this.lang_name)

      this.langs = map(this.locales, ([locale, locale_title]) =>
        defaults(find(langs, { locale }), {
          seq: null,
          name: this.name,
          locale,
          locale_title,
          value: '',
        })
      )
    },
    handleSubmit() {
      this.loading = true
      Promise.all(
        map(filter(this.langs, (lang) => lang.value), (lang) => {
          if (lang.seq) return updateLang(lang)

          return createLang({ ...lang, name: this.lang_name })
        })
      )
        .then(() => {
          if (this.action === 'CREATE') {
            this.init()
            return this.$emit('create')
          }

          this.action = 'READ'

          return this.loadLangs()
        })
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete() {
      const targets = filter(this.langs, ({ seq }) => !!seq)

      if (!targets.length) return

      this.loading = true
      Promise.all(map(targets, ({ seq }) => deleteLang(seq)))
        .then(() => {
          this.$emit('delete')
        })
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<template>
  <tr>
    <td>
      <input
        v-if="action === 'CREATE'"
        v-model="lang_name"
        :disabled="loading"
        :placeholder="$t('admin.lang_item_name')"
        type="text"
        :class="[$style.inputTypeText, $style.fullWidth]"
      />
      <template v-else>{{ lang_name }}</template>
    </td>
    <td v-for="lang in langs" :key="lang.locale">
      <textarea
        v-if="['CREATE', 'UPDATE'].indexOf(action) !== -1"
        v-model="lang.value"
        :placeholder="lang.locale_title"
        :disabled="loading"
        :class="[$style.inputTypeTextArea, $style.fullWidth]"
      ></textarea>
      <template v-else>{{ truncate(lang.value) }}</template>
    </td>
    <td :class="$style.center">
      <a
        v-if="action === 'CREATE'"
        href="#"
        :class="[$style.button, $style.black]"
        @click.prevent="handleSubmit"
        ><span>{{ $t('admin.enroll') }}</span></a
      >&nbsp;
      <template v-if="action === 'READ'">
        <a
          href="#"
          :class="[$style.button, $style.black]"
          @click.prevent="action = 'UPDATE'"
          ><span>{{ $t('admin.modify') }}</span></a
        >&nbsp;
        <a
          href="#"
          :class="[$style.button, $style.red]"
          @click.prevent="handleDelete"
          ><span>{{ $t('lang_search_item.elimination') }}</span></a
        >
      </template>
      <template v-else-if="action === 'UPDATE'">
        <a
          href="#"
          :class="[$style.button, $style.black]"
          @click.prevent="handleSubmit"
          ><span>{{ $t('admin.save') }}</span></a
        >&nbsp;
        <a href="#" :class="[$style.button]" @click.prevent="action = 'READ'"
          ><span>{{ $t('cancel') }}</span></a
        >
      </template>
      <slot name="button" v-bind="$data"></slot>
    </td>
  </tr>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
